// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__NLloi","goldStar":"styles_goldStar__1Dr7h"};